/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {BrowserRouter as Router, Route, Routes} from 'react-router';
import {useCarritoFlotante} from "../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import Seccion_Home from "./Secciones/Seccion_Home";
import Barra from "./Barra/Barra";
import Footer from "./Footer";
import Seccion_Detalles from "./Secciones/Seccion_Detalles";
import Seccione_Catalogo from "./Secciones/Seccione_Catalogo";
import Seccione_Nosotros from "./Secciones/Seccione_Nosotros";
import Seccione_Recibo from "./Secciones/Seccione_Recibo";
import data from '../Modulo_EnviosT1/codigosMexico.json'

const Pagina = () => {
    const {CarritoFlotante} = useCarritoFlotante();

    const minimizar = () =>{

        let arr = []
        for (let i = 0; i < data.length ;i++){
            let obj ={
                "zipcode": data[i].zipcode,
                "state": data[i].state,
                "province": data[i].province,
            }
            arr.unshift(obj)
        }

        const mapaUnico = new Map(arr.map(item => [item.province, item]));

        // Convertimos el Map de vuelta a un arreglo
        let array = Array.from(mapaUnico.values());

        const jsonString = JSON.stringify(array, null, 2);

        // 2. Crear un Blob con el contenido y el tipo MIME correcto
        const blob = new Blob([jsonString], { type: 'application/json' });

        // 3. Crear una URL temporal para ese Blob
        const url = URL.createObjectURL(blob);

        // 4. Crear un elemento <a> invisible para forzar la descarga
        const link = document.createElement('a');
        link.href = url;
        link.download = 'codigosMexico.json';

        // 5. Simular el clic y limpiar la memoria
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);



    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Router>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                    <Barra/>
                </Grid>


                <Routes>
                    <Route path={"*"} element={<Seccion_Home/>}/>
                    <Route path={"/"} element={<Seccion_Home/>}/>
                    <Route path={"/Home"} element={<Seccion_Home/>}/>
                    <Route path={"/Catalogo"} element={<Seccione_Catalogo/>}/>
                    <Route path={"/Catalogo/:tipo/:id"} element={<Seccione_Catalogo/>}/>
                    <Route path={"/Detalle/:id"} element={<Seccion_Detalles/>}/>
                    <Route path={"/Recibo"} element={<Seccione_Recibo/>}/>
                    <Route path={"/Nosotros"} element={<Seccione_Nosotros/>}/>

                </Routes>


                {/*}   <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Button onClick={() =>minimizar()}>minimizar</Button>
                </Grid>*/}

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                    <Footer/>
                </Grid>

                <CarritoFlotante/>


            </Router>

        </Grid>
    )

}
export default Pagina    